import {
  computed, type ComputedRef, onMounted, ref,
} from 'vue'

export default function useBrandingColors(lpuBranding: ComputedRef<{
  primary_color: string
  text_color: string
  background_color: string
} | undefined>) {
  const brandingColors = computed(() => (
    lpuBranding.value
      ? {
        primary: lpuBranding.value.primary_color,
        text: lpuBranding.value.text_color,
        background: lpuBranding.value.background_color,
      }
      : {
        primary: '#1A5DD0',
        text: '#0942A4',
        background: '#DDE7F8',
      }
  ))

  // Используется, чтобы до клиентского рендера уже применялись стили к разметке, который вернул серверный рендер
  const colorVarStyles = ref({
    '--lpu-branding-color-background': brandingColors.value.background,
    '--lpu-branding-color-primary': brandingColors.value.primary,
    '--lpu-branding-color-text': brandingColors.value.text,
  })

  onMounted(() => {
    (Object.keys(colorVarStyles.value) as Array<keyof typeof colorVarStyles['value']>).forEach(colorVarName => {
      document.documentElement.style.setProperty(colorVarName, colorVarStyles.value[colorVarName])
    })
  })

  return {
    brandingColors,
    colorVarStyles,
  }
}
